<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">Multi Day Settings</div>
    <img class="divider" src="assets/img/lobby/ellipse.svg">
    <div class="section">
        Pause Blind Level:
        <app-sopo-select-button
            title="Select Blind Level"
            [(selected)]="blind"
            [list]="blinds">
        </app-sopo-select-button>
    </div>
    <div class="section">
        Resume Date:
        <ion-datetime-button datetime="datetime-multi-day"></ion-datetime-button>
        <ion-modal [keepContentsMounted]="true">
            <ng-template>
                <ion-datetime
                    [showDefaultButtons]="true"
                    color="date-picker"
                    id="datetime-multi-day"
                    [(ngModel)]="resumeDate"
                    [min]="minTimeIsoString"
                    [max]="maxTimeIsoString"
                ></ion-datetime>
            </ng-template>
        </ion-modal>
    </div>
    <div class="sopo-popup-button-container">
        <span (click)="confirm()" [ngClass]="(!resumeDate || !blind) ? 'sopo-popup-grey-button' : 'sopo-popup-green-button'" class="clickable">{{okText}}</span>
        <span class="sopo-popup-red-button clickable" (click)="cancel()">{{cancelText}}</span>
    </div>
</div>